import React from "react";

import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo";
import Features from "components/features/DashedBorderSixFeatures";
import MainFeature from "components/features/TwoColSingleFeatureWithStats2.js";
import MainFeature2 from "components/features/TwoColWithTwoFeaturesAndButtons.js";
import ContactUsBigForm from "../components/forms/TwoColContactUsWithIllustrationFullForm";
import FAQ from "components/faqs/SimpleWithSideImage.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import useAnimatedNavToggler from "helpers/useAnimatedNavToggler.js";
import customerSupportIllustrationSrc from "images/plumbercartoon.svg";
import ThreePlansWithHalfPrimaryBackground from "../components/pricing/ThreePlansWithHalfPrimaryBackground";
import TwoColumnWithImageAndRating from "../components/testimonials/TwoColumnWithImageAndRating";
import GridWithFeaturedPost from "../components/blogs/GridWithFeaturedPost";
import BlogPage from "../components/blogs/BlogPage";

export default () => {
    const  { toggleNavbar } = useAnimatedNavToggler();
    return (
        <div>
            <AnimationRevealPage onClick={toggleNavbar}>
                <Hero/>
                <Features/>
                <div></div>
                <MainFeature/>
                <div></div>
                <ThreePlansWithHalfPrimaryBackground/>
                <div></div>
                <FAQ imageSrc={customerSupportIllustrationSrc} imageContain={true}/>
                <div></div>
                <ContactUsBigForm/>
                <Footer/>
            </AnimationRevealPage>
        </div>
    )
};
